/* ============================================================
   HIT: o Comprar da página de produto vai à sacola (Tarefa 20, parte A; a B em direcao-b/index.html, adicionar, B:1602–1607).
   Registra o tratador do HitProduto.aoAdicionar (assets/hit-produto.js, que carrega antes, defer, pelo snippets/scripts-produto):
     POST /cart/add.js com a variante e a quantidade, com prazo de PRAZO ms. Sucesso: atualiza o número da sacola no cabeçalho (#n-h) e na
     barra de baixo (#n-m) e o nome acessível dos dois links (.abre-sacola), sem recarregar, e devolve true; o hit-produto.js abre a gaveta
     da sacola e fala "Produto adicionado à sacola." na região #compra-anuncio (a mensagem e o foco são dele). Falha (422
     sem estoque, 4xx, 5xx, ou a resposta redirecionada, que não é o JSON do add.js): devolve false, e o hit-produto.js mostra a
     mensagem de falha na região #compra-anuncio e no aviso, sem mudar o rótulo do botão. Sem resposta (prazo ou queda da conexão), o pedido pode ter chegado à
     loja: o GET /cart.js diz se a variante está na sacola, e só então é sucesso. LIMITE: a variante que já estava na sacola antes do
     pedido também aparece lá, e conta como sucesso. O add.js e os dois GET (naSacola e rotuloPorGet) têm prazo de PRAZO ms (HitSacola.prazo, ou o
     prazoLocal daqui quando o hit-sacola.js não carregou; os dois cobrem o navegador sem AbortSignal.timeout): o botão Adicionar nunca fica preso a uma leitura pendurada.
   O número e o nome vêm da seção sections/rotulo-sacola (o texto do locale com o plural da Shopify, nada de texto fixo aqui), pedida
   junto do add.js (Section Rendering API); se ela não vier, um GET /?section_id=rotulo-sacola. O aviso de falha vai ao console como
   warn: a recusa é da loja ou da rede, não um defeito do tema, e o tratador nunca lança (o hit-produto.js trataria como erro).
   A GAVETA DA SACOLA (Tarefa 21, assets/hit-sacola.js) pede também a seção cart-drawer no mesmo add.js: a resposta a entrega a
   HitSacola.sincroniza(secoes, marca) (a fila dos cliques da gaveta; marca = HitSacola.marca() de antes do pedido), e "ver sacola" (hit-produto.js, G.abrir('sacola')) abre a gaveta JÁ com o item. Se a seção
   não veio, ou há uma mudança da gaveta ainda no ar, a própria sincroniza lê a sacola com um GET. Sem o hit-sacola.js ou sem a gaveta, "ver sacola" leva a /cart (hit-produto.js, D.carrinho).
   ============================================================ */
(function () {
  'use strict';
  const HP = window.HitProduto;
  if (!HP) return; // fora da página de produto, ou o hit-produto.js não ligou (ele já avisou)
  const RAIZ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const SECAO = 'rotulo-sacola';
  const SECOES = `cart-drawer,${SECAO}`; // a gaveta (hit-sacola.js) e o número/nome do link, numa só resposta
  const PRAZO = 15000; // ms: o /cart/add.js sem resposta nesse tempo é cortado, e o /cart.js diz se entrou
  const aviso = (msg, e) => console.warn(`hit-sacola-produto.js: ${msg}`, e || '');
  /* o prazo de um fetch ({ signal, limpa }): o do HitSacola quando o hit-sacola.js carregou; senão o daqui, que tem a mesma reserva e não depende dele:
     AbortSignal.timeout onde existe; sem ele (Safari antes do 16, iOS 15), um AbortController com setTimeout, desarmado em limpa() */
  const prazoLocal = (ms) => {
    if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') return { signal: AbortSignal.timeout(ms), limpa() {} };
    if (typeof AbortController !== 'function') return { signal: undefined, limpa() {} };
    const c = new AbortController(), t = setTimeout(() => c.abort(), ms);
    return { signal: c.signal, limpa() { clearTimeout(t); } };
  };
  const prazo = (ms) => (window.HitSacola && window.HitSacola.prazo ? window.HitSacola.prazo(ms) : prazoLocal(ms));

  /* o número e o nome da sacola no HTML da seção: { n, rotulo }, ou null quando não vieram */
  function leRotulo(html) {
    if (typeof html !== 'string' || !html) return null;
    const s = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-n]');
    const n = s ? Number(s.getAttribute('data-n')) : NaN, rotulo = s ? s.getAttribute('data-rotulo') : '';
    return Number.isInteger(n) && n >= 0 && rotulo ? { n, rotulo } : null;
  }
  async function rotuloPorGet() {
    const p = prazo(PRAZO);
    try {
      const r = await fetch(`${RAIZ}?section_id=${SECAO}`, { cache: 'no-store', headers: { Accept: 'text/html' }, signal: p.signal });
      return r.ok ? leRotulo(await r.text()) : null;
    } catch (e) { return null; } finally { p.limpa(); }
  }
  function poeRotulo({ n, rotulo }) {
    document.querySelectorAll('.abre-sacola').forEach((a) => a.setAttribute('aria-label', rotulo));
    document.querySelectorAll('.abre-sacola .ns').forEach((s) => { s.textContent = String(n); s.hidden = n === 0; });
  }
  /* a variante está na sacola? true, false, ou null quando o /cart.js não respondeu */
  async function naSacola(variante) {
    const p = prazo(PRAZO);
    try {
      const r = await fetch(`${RAIZ}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' }, signal: p.signal });
      if (!r.ok) return null;
      const c = await r.json();
      return Array.isArray(c.items) && c.items.some((i) => Number(i.variant_id) === Number(variante));
    } catch (e) { return null; } finally { p.limpa(); }
  }
  async function adiciona({ variante, quantidade }) {
    const marca = window.HitSacola && window.HitSacola.marca(); // a gaveta mexeu até a resposta chegar? Então as seções do add já são velhas
    let j = null;
    const p = prazo(PRAZO);
    try {
      const r = await fetch(`${RAIZ}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variante, quantity: quantidade }], sections: SECOES }),
        signal: p.signal,
      });
      if (!r.ok || r.redirected) { aviso(`o /cart/add.js recusou (HTTP ${r.status}${r.redirected ? ', redirecionado' : ''})`); return false; }
      j = await r.json().catch(() => null);
    } catch (e) {
      aviso('o /cart/add.js não respondeu; o /cart.js diz se entrou', e);
      if (await naSacola(variante) !== true) return false;
    } finally { p.limpa(); }
    // a gaveta recebe a sacola nova (e, de passagem, o número e o nome dos links); sem ela, a seção rotulo-sacola faz só o número
    const gaveta = window.HitSacola;
    const secoes = j && j.sections;
    const naGaveta = gaveta && await gaveta.sincroniza(secoes, marca); // na fila da gaveta: uma resposta velha nunca sobrescreve a nova
    if (!naGaveta) {
      const rot = leRotulo(secoes && secoes[SECAO]) || await rotuloPorGet();
      if (rot) poeRotulo(rot);
      else aviso('o produto entrou na sacola, mas o número não veio (seção rotulo-sacola)');
    }
    return true;
  }
  HP.aoAdicionar(adiciona);
})();
